<template>
  <div class="content-fix ant-row">
    <div class="content-title ant-row-flex">
      <slot name="title">
        <h2>{{ title }}</h2>
      </slot>

      <slot name="action">
        <a-button
          style="margin-left: auto"
          type="primary"
          @click="$emit('addBtn', $event)"
        >
          <a-icon type="plus" />Добавить
        </a-button>
      </slot>
    </div>

    <a-col :class="wrapperClass">
      <slot />
    </a-col>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    wrapperClass: {
      type: String,
      default: () => ""
    }
  }
}
</script>
